export const USER_MANUAL_BUTTON_LABEL = 'Help';
export const USER_MANUAL_PANEL_TITLE = 'User manual';
export const USER_MANUAL_CLOSE_LABEL = 'Close';
export const USER_MANUAL_LOAD_ERROR = 'The user manual could not be loaded.';

export const USER_MANUAL_DOCUMENT_PATH =
  '/user-manual/review-draft-productions-and-organizations.en.md';
export const USER_MANUAL_ASSET_BASE_PATH = '/user-manual/';

export const USER_MANUAL_PANEL_WIDTH = '33vw';
export const USER_MANUAL_PANEL_MIN_WIDTH_PX = 320;
export const USER_MANUAL_PANEL_MAX_WIDTH_PX = 520;

export const USER_MANUAL_LINK_TARGET = '_blank';
export const USER_MANUAL_LINK_REL = 'noopener noreferrer';
export const USER_MANUAL_ANCHOR_PREFIX = '#';
export const USER_MANUAL_RELATIVE_PATH_PREFIX = './';

export const USER_MANUAL_IMAGE_ZOOM_FACTOR = 3;
export const USER_MANUAL_IMAGE_PREVIEW_MAX_WIDTH = '90vw';
export const USER_MANUAL_IMAGE_PREVIEW_MAX_HEIGHT = '90vh';
export const USER_MANUAL_IMAGE_ENLARGE_LABEL = 'Enlarge image';
export const USER_MANUAL_IMAGE_OPEN_KEY_ENTER = 'Enter';
export const USER_MANUAL_IMAGE_OPEN_KEY_SPACE = ' ';
